import { getConfig, getPortfolioConfig } from '@/data/config'

/** In debug mode, lists the market properties the server left out of the portfolio. */
export function warnSkippedProperties (): void {
	if (!getConfig().debugMode) return
	const skipped = getPortfolioConfig()?.skippedProperties ?? []
	if (skipped.length === 0) return
	// eslint-disable-next-line no-console
	console.warn(`[Spaces:Portfolio] ${skipped.length} property(s) skipped for missing map location`, skipped)
}
